<template>
  <div class="html-content" v-html="normalized"></div>
</template>

<script>
export default {
  name: "HtmlContent",
  props: {
    html: {
      type: String,
      default: "",
    },
  },
  computed: {
    normalized() {
      return String(this.html || "")
        .replace(/<\s*\/\s*br\s*>/gi, "<br>")
        .replace(/<\s*br\s*>/gi, "<br>")
    },
  },
}
</script>

<style>
.html-content {
  font-weight: bold;
  white-space: pre-line;
  color: inherit;
}

.html-content p {
  margin: 0 0 0.4em;
}

.html-content p:last-child {
  margin-bottom: 0;
}
</style>
